function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}
module.exports = _isTransformer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isTransformer.js
// module id = 141
// module chunks = 0